import { Component, OnInit, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { CommonService } from '../services';
import { ShoppingCartService } from '../services/shopping-cart.service';
import { DDFSQuoteModel } from '../models/shopping-cart.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.css']
})
export class FinanceComponent implements OnInit, OnDestroy {

  title: string = "Finance";
  loadContent: boolean = false;
  hideBreadcrumb: boolean = false;
  financeFor: string;
  cartId: string;
  cartName: string;
  quote: DDFSQuoteModel;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent;
  
  setFullWindow = false;

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private commonService: CommonService,
    private shoppingCartService: ShoppingCartService
  ) { }

  ngOnInit() {
    this.loadContent = false;
    this.financeFor = "enduser";
    this.hideBreadcrumb = false;
    this.cartId = "";
    if (this.activeRouter.parent) {
      this.activeRouter.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
        $('#levelOne').animate({ scrollLeft: $('#cart-summary').width() + 250 }, 400);
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
      // this.activeRouter.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      //   if (res) {
      //     this.hideBreadcrumb = true;
      //     this.cartId = res.get("id");
      //     this.cartName = res.get("cartName");
      //     this.shoppingCartService.GetFinanceQuoteByCartId(_.toNumber(this.cartId), this.financeFor, true).subscribe((res: DDFSQuoteResponse) => {
      //       if (res && res.quote) {
      //         this.quote = res.quote;
      //         this.quote.financeType = this.financeFor == "me" ? 1 : 2;
      //         this.shoppingCartService.SaveQuoteDetail(this.quote).subscribe((result: ApiResponse) => {
      //           if (result && result.status) {
      //             this.router.navigate(['financeDetails/' + this.financeFor], { relativeTo: this.activeRouter });
      //           }
      //           else {
      //             this.commonService.showError(".financenext", result.responseMessage, "right");
      //           }
      //         });
      //       }
      //     },
      //       (error: any) => {
      //         console.info(error);
      //         this.loadContent = true;
      //       });
      //   } else {
      //     this.hideBreadcrumb = false;
      //   }
      //   this.loadContent = true;
      // },
      //   (error: any) => {
      //     console.info(error);
      //     this.loadContent = true;
      //   });
      this.activeRouter.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        if (res) {
          this.hideBreadcrumb = true;
          this.cartId = res.get("id");
          this.cartName = res.get("cartName");
          this.router.navigate(['financeDetails/' + this.financeFor], { relativeTo: this.activeRouter });
        } else {
          this.hideBreadcrumb = false;
        }
        this.loadContent = true;
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  showFinanceDetails(): void {
    this.router.navigate(['financeDetails/' + this.financeFor], { relativeTo: this.activeRouter });
  }

  close(): void {
    if (this.cartId) {
      this.router.navigateByUrl("/myCarts/cart/" + this.cartId + "/" + this.cartName);
    } else {
      this.router.navigateByUrl("/home");
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
